import { TableCell, TableRow } from '@repo/ui/components'
import { LucideIcon } from 'lucide-react'
import { Text } from '../Atoms'
import { HStack } from '../Atoms/Layout/HStack'

export function TableMessage(props: { message: string; icon?: LucideIcon; colSpan: number }) {
  return (
    <TableRow>
      <TableCell colSpan={props.colSpan} className="h-96">
        <div className="flex h-full items-center justify-center">
          <HStack align="center" gap="sm">
            {props.icon && <props.icon className="text-muted-foreground size-4" />}
            <Text tone="muted" className="select-none">
              {props.message}
            </Text>
          </HStack>
        </div>
      </TableCell>
    </TableRow>
  )
}
